import { Image } from "@mui/icons-material";
import {
	Autocomplete,
	Avatar,
	Box,
	ListItem,
	ListItemAvatar,
	ListItemText,
	TextField,
	Toolbar,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { getAllPlayoffs } from "../../apis/Playoff";
import { axiosInstance } from "../../config/axios";
import { FilterAutocomplete } from "../Form/FilterAutocomplete";
import DragAndDropItems from "./DragAndDropItems";

export const Product = () => {
	const [products, setProducts] = useState([]);
	const [groups, setGroups] = useState([]);
	const [option, setOption] = useState(null);

	useEffect(() => {
		const fetchProducts = async () => {
			if (option) {
				setProducts([]);
				const res = await axiosInstance.get(`group-products/${option.id}/`);
				const { data } = res;
				setProducts(
					data.map((product) => ({
						id: product.id,
						label: product.name,
						icon: product.image.file,
						category: "",
					})) || []
				);
			}
		};

		fetchProducts();
	}, [option]);

	const handleChange = (name, item) => {
		setGroups(item?.groups || []);
		setOption(null);
		setProducts([]);
	};

	const handleChangeOrder = async (values) => {
		const order = values.map((item, index) => ({
			id: item.id,
			order: index + 1,
		}));
		const res = await axiosInstance.post("product-order", order);
		console.log("====================================");
		console.log(res);
		console.log("====================================");

		// alert("Current order:\n" + order.join("\n"));
		console.log("Current order:", order);
	};

	return (
		<Box>
			<Toolbar disableGutters>
				<Typography variant="h4" component="div" sx={{ flexGrow: 1 }}>
					Product Ordering
				</Typography>

				<Box sx={{ width: { xs: "100%", md: "25%", xl: "20%" } }}>
					<FilterAutocomplete
						fetchOptions={getAllPlayoffs}
						label={"Playoff"}
						handleChange={handleChange}
						name={"playoff"}
						reset={false}
						setReset={() => { }}
					/>
				</Box>
				{groups.length > 0 && (
					<Box
						sx={{
							ml: { xs: "inherit", sm: 1 },
							width: { xs: "100%", md: "25%", xl: "20%" },
						}}
					>
						<Autocomplete
							options={groups}
							// loading={loading}
							value={option}
							getOptionLabel={(option) =>
								typeof option === "string"
									? option
									: option?.name
										? option?.name
										: option?.title || ""
							}
							clearOnEscape={true}
							isOptionEqualToValue={(option, value) =>
								option?.id === value?.id
							}
							onChange={(e, newValue) => setOption(newValue)}
							renderOption={(props, option) => (
								<ListItem {...props} key={option.id}>
									<ListItemAvatar>
										<Avatar src={option.icon}>
											<Image />
										</Avatar>
									</ListItemAvatar>

									<ListItemText
										primary={option.name}
										secondary={option.category?.name}
									/>
								</ListItem>
							)}
							renderInput={(params) => (
								<TextField {...params} label={"Group"} />
							)}
						/>
					</Box>
				)}
			</Toolbar>
			<Box pt={3}>
				{products.length ? (
					<DragAndDropItems
						items={products}
						handleChange={handleChangeOrder}
					/>
				) : (
					<></>
				)}
			</Box>
		</Box>
	);
};
